import { createSelector } from '@ngrx/store';
import { AppState, GeneralState } from '../app.state';

export const selectGeneralState = createSelector(
	(state: AppState) => state.general,
	(general: GeneralState) => general
);
